import { render } from "./FakeDoor.vue?vue&type=template&id=127a0cd4&scoped=true"
import script from "./FakeDoor.vue?vue&type=script&lang=js"
export * from "./FakeDoor.vue?vue&type=script&lang=js"

import "./FakeDoor.vue?vue&type=style&index=0&id=127a0cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127a0cd4"]])

export default __exports__